import { useParams } from "react-router-dom";
import useAgentDetail from "../../hooks/agent/useAgentDetail";
import LoadingSpinner from "../../components/common/LoadingSpinner";
import AgentPanel from "../../components/agent/AgentPanel";
import Header from "../../components/ui/Header";
import Footer from "../../components/ui/Footer";

export default function AgentDetail() {
  const { agentId } = useParams();
  const { schema, isLoading, error } = useAgentDetail({ agentId });

  if (isLoading) {
    return (
      <div className="min-h-screen pt-[100px] font-serif-kr">
        <LoadingSpinner 
          message="에이전트 정보를 불러오는 중"
          size="lg"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen pt-[100px] flex items-center justify-center font-serif-kr">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">오류 발생</h1>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!schema || !schema.data) {
    return (
      <div className="min-h-screen pt-[100px] flex items-center justify-center font-serif-kr">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-800 mb-4">데이터 없음</h1>
          <p className="text-gray-600">에이전트 정보를 찾을 수 없습니다.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-6xl mx-auto px-5 py-8">
          <AgentPanel agent={schema.data} relations={schema.relations} />
        </div>
      </div>
      <Footer />
    </>
  );
}
